/**
 * Taklifnoma shablonlari
 * Har bir shablon — React komponenti bo'lib, quyidagi props qabul qiladi:
 *   - data: { groomName, brideName, date, time, venue, address, message, qrValue }
 *   - style: optional inline style overrides
 *
 * Yangi shablon qo'shish uchun:
 *   1. Bu papkada TemplateXxx.jsx fayl yarating (cardSize.js dagi CARD_W/CARD_H dan foydalaning)
 *   2. TEMPLATES massiviga qo'shing
 */

import ClassicGold from './ClassicGold';
import FloralPink from './FloralPink';
import ModernMinimal from './ModernMinimal';
import NavyGold from './NavyGold';
import BohoGreenery from './BohoGreenery';

const TEMPLATES = [
  {
    id: 'classic-gold',
    name: 'Klassik oltin',
    description: 'An\'anaviy oltin rangdagi bezakli shablon',
    color: '#B8860B',
    preview: '🏛️',
    component: ClassicGold,
  },
  {
    id: 'floral-pink',
    name: 'Gullar — pushti',
    description: 'Gul naqshli pushti shablon',
    color: '#E91E63',
    preview: '🌸',
    component: FloralPink,
  },
  {
    id: 'modern-minimal',
    name: 'Zamonaviy minimal',
    description: 'Oddiy va zamonaviy uslubdagi shablon',
    color: '#5F33E1',
    preview: '✨',
    component: ModernMinimal,
  },
  {
    id: 'navy-gold',
    name: 'Navy & Gold',
    description: 'Hashamatli ko\'k-oltin rangdagi nafis shablon',
    color: '#D4AF37',
    preview: '👑',
    component: NavyGold,
  },
  {
    id: 'boho-greenery',
    name: 'Boho — yashil bargli',
    description: 'Tabiiy, zamonaviy boho uslubidagi shablon',
    color: '#7C9473',
    preview: '🌿',
    component: BohoGreenery,
  },
];

export default TEMPLATES;
